import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtml',
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string): string {
    let strippedString = value.replace(/(<([^>]+)>)/gi, '');
    var dom = new DOMParser().parseFromString(value, 'text/html');
    var txt = dom.body.textContent;
    return txt;
  }
}
